import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../components/misc';
import { Redirect } from 'react-router-dom';

import GDPRHint from '../components/content/GDPRHint';
import LoadingPlaceholder from '../components/content/loading/LoadingPlaceholder';
import LoginForm from '../components/content/LoginForm';
import withRequestHandler from '../components/hoc/withRequestHandler';
import withUserConsumer from '../components/hoc/withUserConsumer';
import withNotificationDialogConsumer from '../components/hoc/withNotificationDialogConsumer';

import RequestLoginMutation from '../mutations/RequestLoginMutation';

import environment from '../environment';

import LoginRedirectConfirmDialog from '../components/content/dialogs/LoginRedirectionConfirmDialog';

import ReactCardFlip from 'react-card-flip';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { PrimaryButton } from '../components/misc/Buttons';

import { MAGIC_LINK_SENT_MSG, NEW_SYSTEM_ORDER_REDIRECT_MSG } from '../utils/variables';
import { setToLocalStorage } from '../utils/browser-storage';

const LoginPage = (props) => {

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);

  React.useEffect(() => {
    const { history, location, onOpenNotificationDialog } = props;

    if (location.search) {
      if (location.search === '?old') {
        onOpenNotificationDialog(NEW_SYSTEM_ORDER_REDIRECT_MSG, () => {
          history.replace(location.pathname);
        });
      }
    }
  },[]);

  const handleClickOpen = () => {
    setOpenConfirmDialog(true);
  };

  const handleConfirm = () => {
    _redirectToArchiveLoginPage();
  };

  const handleClose = () => {
    setOpenConfirmDialog(false);
  };

  const handleClick = (e) => {
    e.preventDefault();
    setIsFlipped(!isFlipped);
  }


  const handleRequestLogin = email => {
    setToLocalStorage('email', email);
    const { match, history, onRequestStart, onRequestStop, onRequestError } = props;
    onRequestStart();
    RequestLoginMutation.commit(
      environment,
      email,
      false,
      match.params.language,
      (error, res) => {
        if (error) {
          onRequestError(error);
          // Here it's necessary to replace the path with '/:language/login'. Otherwise
          // the component will be unmounted and remounted. This causes the state to be
          // reset and the ErrorDialog not to be displayed.
          history.replace(`/${match.params.language}/login`);
        } else {
          props.onOpenNotificationDialog(MAGIC_LINK_SENT_MSG);
          onRequestStop();
        }
      },
    );
  };

  const _redirectToArchiveLoginPage = () => {
    window.location.href = 'https://archive.sportograf.com/account/signin';
  };


  const {
    isLoggedIn,
    isLoading,
    onOpenNotificationDialog,
  } = props;
  if (isLoggedIn) {
    return <Redirect to="/account/events" />;
  }

  return (
    <div className="container-page container-960 login-page">
      <ReactCardFlip isFlipped={isFlipped} flipDirection="vertical">
        <div className="row flex-center">
          <div className="col-xs-16 col-sm-6 login-choice-container">
            <div className="login-choice-container-child">
              <h3>
                <FormattedMessageWrappedInSpan
                  id="loginPage.redirection.title"
                  defaultMessage="For orders of events before 2019"
                />
              </h3>
              <PrimaryButton
                leftLabel={
                  <FormattedMessageWrappedInSpan id="loginPage.redirection.button" defaultMessage="Go to Sportograf Archive" />
                }
                onClick={handleClickOpen}
              />
              <LoginRedirectConfirmDialog
                open={openConfirmDialog}
                onRequestClose={handleClose}
                onAcceptClick={handleConfirm}
              />
            </div>
            <div className="login-choice-container-child">
              <h3>
                <FormattedMessageWrappedInSpan
                  id="loginPage.toLogin.title"
                  defaultMessage="For newer orders"
                />
              </h3>
              <PrimaryButton
                leftLabel={
                  <FormattedMessageWrappedInSpan id="loginPage.toLogin.button" defaultMessage="Go to Login Page" />
                }
                onClick={handleClick}
              />
            </div>
          </div>
        </div>
        <div className="row flex-center">
          <div className="col-xs-16 col-sm-6 login-container">
              <h2>
                <FormattedMessageWrappedInSpan id="loginPage.title" defaultMessage="Signup / Login" />
              </h2>
              <LoadingPlaceholder isLoading={isLoading}>
                <LoginForm
                  isLoginPage={isFlipped}
                  onRequestLogin={handleRequestLogin}
                  onOpenNotificationDialog={onOpenNotificationDialog}
                />
                <GDPRHint className="mt-30 center-text" />
              </LoadingPlaceholder>
              <IconButton
                classes={{ root: 'login-container-close-icon-btn' }}
                onClick={handleClick}
              >
                <ArrowBackIcon />
              </IconButton>
            </div>
        </div>
      </ReactCardFlip>
    </div>
  );

}

LoginPage.propTypes = {
  isLoggedIn: PropTypes.bool,
  isLoading: PropTypes.bool,
  location: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  onOpenNotificationDialog: PropTypes.func,
  onRequestStart: PropTypes.func,
  onRequestStop: PropTypes.func,
  onRequestError: PropTypes.func,
};

const WithNotificationDialogHoc = withNotificationDialogConsumer(LoginPage);
const WithUserConsumerHoc = withUserConsumer(WithNotificationDialogHoc);
const WithRequestHandlerHoc = withRequestHandler(WithUserConsumerHoc);

export { LoginPage };
export default WithRequestHandlerHoc;
